import CloseIcon from '../assets/close-icon.svg';
import CustomButton from '../reusable/CustomButton';
import CustomDivider from '../reusable/CustomDivider';
import InfoIcon from '../assets/info-icon.svg';
import CustomTooltip from '../reusable/CustomTooltip';

import './SideDrawer.css';
import { IconButton } from '@mui/material';

interface SideDrawerProps {
  title: string;
  description?: string;
  handleClose: () => void;
  children: React.ReactNode;
  isOpen: boolean;
  classes?: string[];
  infoIcon?: boolean;
  divider?: boolean;
}

const tooltipTitle =
  "Compare the demographics of your selected transcripts' students with the school’s overall demographics. Aligning the two will ensure that the selected students accurately represent the diversity of experiences at the school.";

function SideDrawer({
  title,
  description,
  handleClose,
  children,
  isOpen,
  classes,
  infoIcon,
  divider = true,
}: SideDrawerProps) {
  const classNames = classes ? classes.join(' ') : '';

  return (
    <div
      data-testid="side-drawer-container"
      className={`side-drawer-container ${!isOpen ? 'closed' : ''} ${classNames}`}
    >
      <div className={`side-drawer-header ${title === 'Demographics match' ? 'in-transcript-selection' : ''}`}>
        <p>{title}</p>
        {infoIcon && (
          <CustomTooltip placement="top" title={tooltipTitle} arrow={true}>
            <IconButton className="info-icon" sx={{ '&:hover': { backgroundColor: 'var(--background-white)' } }}>
              <img className="icon-size" src={InfoIcon} alt="drawer header info icon" />
            </IconButton>
          </CustomTooltip>
        )}
        <CustomButton className="close-icon" buttonAction={handleClose} buttonText="" variant="clear">
          <img src={CloseIcon} alt="close modal" />
        </CustomButton>
      </div>
      {description && <p className="side-drawer-description">{description}</p>}
      {divider && <CustomDivider orientation="horizontal" />}
      <div className="side-drawer-content">{children}</div>
    </div>
  );
}

export default SideDrawer;
